var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobHiVeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 67,
    viewBox: "0 0 146 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0703125 1.84473L16.4727 63.065H29.6409L24.2806 43.0584H41.5928L37.8387 30.3523H20.8763L13.2384 1.84473H0.0703125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.601 63.5966L52.8913 15.6477L39.4922 15.1279L53.7477 63.5966H67.601Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.08 12.1567L128.23 0L132.352 12.7915L116.371 24.8208L119.176 33.1023L135.113 21.3612L139.265 34.2462L136.922 36.0185L123.469 45.7719L126.212 53.8682L141.805 42.1311L145.861 54.7176L130.335 66.0365L130.362 66.1157L130.263 66.0891L129.761 66.4553L129.585 65.9066L114.287 61.7877L101.303 20.3715L112.045 12.0548L112.08 12.1567Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.6834 63.0325L91.5505 60.0453L102.253 42.819L97.4886 26.7922L83.9014 47.696L80.4067 36.3044H66.899L74.7603 63.0325H89.6834ZM78.2207 29.1789L74.073 15.6585L60.6738 15.1387L64.8033 29.1789H78.2207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobHiVeLogo);
export default __webpack_public_path__ + "static/media/MobHIVeLogo.3d9466cf7c1281d29c1bc0bf04526a4c.svg";
export { ForwardRef as ReactComponent };